import React, { useEffect, useState } from 'react'


function LoginBox(props) {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    
    return (
        <div className='w-[90%] mx-auto py-6'>
            <div className='input_container'>
                <img src={window.location.origin + '/userIcon.svg'} className="auth_icon"></img>
                <input
                    placeholder='Enter the Email'
                    className='inp_fields outline-none'
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className='input_container'>
                <img src={window.location.origin + '/lockIcon.svg'} className="auth_icon"></img>
                <input
                    placeholder='Enter the Password'
                    className='inp_fields outline-none   '
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <div style={{paddingBottom: 30}} className='button_wrapper '>
                <div className='login_button my-4 shadow-lg cursor-pointer' onClick={() => props.handleLoginWithCred(email, password)}>
                    <a className='signin_text'>Log In</a>
                </div>
                <div className='google_button my-4 shadow-lg cursor-pointer'>
                    <img src={window.location.origin + '/googleLogo.svg'} className="brand_logo"></img>
                    <a className='signin_google' onClick={() => props.handleClick()}>Sign In with Google</a>
                </div>
                <div className='apple_button my-4 shadow-lg cursor-pointer'>
                    <img src={window.location.origin + '/appleLogo.svg'} className="brand_logo"></img>
                    <a className='signin_text' onClick={() => props.signInWithApple()}>Sign In with Apple</a>
                </div>
                <a></a>
            </div>
        </div>
    )
}

export default LoginBox